import { QueryUtil } from "@base/util/QueryUtil";

const params = QueryUtil.toObject(globalThis?.location?.href || "") as any;

export class Dev {
  static isSandy(type?: "lines"): boolean {
    return Dev.checkParam("sandy", type);
  }
  static isTreeNew(): boolean {
    return Dev.checkParam("groups");
  }
  static checkParam(urlParamName: string, value?: string): boolean {
    const p = params[urlParamName];
    if (value)
      return p === value;
    return p !== "false" && p !== undefined;
  }
}